import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyCampaign({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.84 151c40.2-9.93 77 7.5 102 7.5 40.5 0 63.07-21.6 54.5-63-8.03-38.73-50.46-35.7-86-55.5-109.5-61-112.5 6-126 48s13 73.5 55.5 63z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.1 114.22c-23.7 7.6-54.8 6.97-100.81-7.72-61.24-19.54-92.67 2.03-112.33 23.11 8.33 18.27 28.53 27.9 54.88 21.39 26.22-6.48 50.98-1.32 71.98 3.06 11.2 2.33 21.32 4.44 30.02 4.44 33.87 0 55.2-15.11 56.26-44.28z"
        fill="#8F9DD6"
      />
      <path
        d="M96.75 53.36a6.64 6.64 0 00-9.04-1.59 6.5 6.5 0 00-1.6 9.04l40.87 58.36a6.47 6.47 0 009.04 1.6 6.5 6.5 0 001.6-9.05L96.74 53.36z"
        fill="#6C7EC9"
      />
      <path
        d="M81.25 119.95l-11.9-17a5.77 5.77 0 00-7.85-1.38l-11.28 7.9a5.64 5.64 0 00-1.38 7.85l11.9 16.99a5.6 5.6 0 007.85 1.38l11.27-7.89a5.65 5.65 0 001.39-7.85z"
        fill="#666"
      />
      <path
        d="M125.3 91.5a5.64 5.64 0 001.38-7.85l-6.22-8.88a5.65 5.65 0 00-7.85-1.39l-1.24.87 12.68 18.12 1.24-.87z"
        fill="#FF952B"
      />
      <path
        d="M79.2 128.23l-11.14 7.8 11.77 16.8a1.53 1.53 0 002.14.38 12.06 12.06 0 002.96-16.79l-5.74-8.2z"
        fill="#6C7EC9"
      />
      <path
        d="M67.86 101.5c.46.42.89.88 1.26 1.4l11.9 17c.37.53.66 1.1.9 1.67 15.03-8.15 34.46-6.39 43.39-4.96L87.36 62.4c-1.7 8.88-6.7 27.74-19.5 39.08z"
        fill="#7E90DC"
      />
      <path
        opacity={0.7}
        d="M152.17 92.35l-11.36-3.86m10.92-14.9l-11.64 2.89M139.71 55L133 64.95M122.88 48L121 59.85"
        stroke="#8F9DD6"
        strokeWidth={4}
        strokeLinecap="round"
      />
      <path
        d="M198.26 21h-37.52a7.75 7.75 0 00-7.74 7.75v29.77a7.75 7.75 0 007.74 7.75h9.83l7.21 8.4a2.11 2.11 0 003.44 0l7.21-8.4h9.83a7.75 7.75 0 007.74-7.75V28.75a7.75 7.75 0 00-7.74-7.75z"
        fill="#fff"
        filter="url(#pic-empty-campaign_svg__a)"
      />
      <path
        d="M178.66 28.22a2 2 0 012.68 0l2.7 2.45a2 2 0 001.43.52l3.64-.14a2 2 0 012.06 1.73l.5 3.61a2 2 0 00.75 1.31l2.89 2.24a2 2 0 01.46 2.64l-1.94 3.09a2 2 0 00-.26 1.49l.77 3.57a2 2 0 01-1.34 2.32l-3.48 1.12a2 2 0 00-1.16.97l-1.7 3.23a2 2 0 01-2.53.92l-3.37-1.38a2 2 0 00-1.52 0l-3.37 1.38a2 2 0 01-2.53-.92l-1.7-3.23a2 2 0 00-1.16-.97l-3.47-1.12a2 2 0 01-1.35-2.32l.77-3.57a2 2 0 00-.26-1.49l-1.94-3.09a2 2 0 01.46-2.64l2.89-2.24a2 2 0 00.75-1.3l.5-3.62a2 2 0 012.06-1.73l3.64.14a2 2 0 001.42-.52l2.7-2.45z"
        fill="#FB8F23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.32 40.16a2.16 2.16 0 11-4.32 0 2.16 2.16 0 014.32 0zm-3.8 7.97c0 .37.14.7.4.96a1.33 1.33 0 001.9 0l8.27-8.27a1.33 1.33 0 000-1.9 1.37 1.37 0 00-1.9 0l-8.28 8.26c-.25.26-.4.59-.4.95zm9.32 1.87a2.16 2.16 0 100-4.32 2.16 2.16 0 000 4.32z"
        fill="#fff"
      />
      <defs>
        <filter
          id="pic-empty-campaign_svg__a"
          x={149}
          y={19}
          width={61}
          height={62.55}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2016_1448" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2016_1448" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyCampaign.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyCampaign.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyCampaign svgRef={ref} {...props} />
));
export default ForwardRef;
